import { dmyToYmd } from './reportDateParams'

export function readGenericReportSession(
  key: string,
): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const value = JSON.parse(raw) as unknown
    return value && typeof value === 'object' && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null
  } catch {
    return null
  }
}

export function writeGenericReportSession(
  key: string,
  data: Record<string, unknown>,
): void {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export function clearGenericReportSession(key: string): void {
  sessionStorage.removeItem(key)
}

export function normalizeSessionPatch(
  session: Record<string, unknown>,
  defaults: Record<string, unknown>,
): Record<string, unknown> {
  const patch: Record<string, unknown> = {}
  for (const key of Object.keys(defaults)) {
    const value = session[key] ?? session[`${key}[]`]
    if (value == null) continue
    if (typeof defaults[key] === 'number') {
      const n = Number(value)
      if (Number.isFinite(n)) patch[key] = n
      continue
    }
    if (Array.isArray(defaults[key])) {
      patch[key] = Array.isArray(value)
        ? value.map(String).filter(Boolean)
        : String(value)
          ? [String(value)]
          : []
      continue
    }
    const stringValue = String(value)
    patch[key] =
      /(?:^|_)(fromDt|toDt|claimfromDt|claimtoDt)$/.test(key) ||
      key === 'fromDt' ||
      key === 'toDt'
        ? dmyToYmd(stringValue) || stringValue
        : stringValue
  }
  return patch
}
